function init() {
  //place the congif
}
function log(error) {
  //Raven.captureException(error)
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  init,
  log
};
